module.exports = require("@segment/analytics-node");